module.exports = __webpack_public_path__ + "fe998508e48b9ffc27387d1fc08bfef8.svg";